import React, { lazy, memo } from 'react';
const Story = () => {
  return <section className="py-16 md:py-24 bg-gradient-to-b from-white to-[#f8f9ff]" data-id="element-372">
      <div className="container mx-auto px-4 md:px-6" data-id="element-373">
        <div className="max-w-4xl mx-auto" data-id="element-374">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-375">
            <div className="p-8 md:p-12" data-id="element-376">
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-[#1e293b] text-center" data-id="element-377">
                La historia de Sofía
              </h2>
              <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-378">
                <div className="md:w-1/3" data-id="element-379">
                  <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=764&q=80" alt="Sofía" className="w-full h-auto rounded-lg shadow-md" width="400" height="600" loading="lazy" data-id="element-380" />
                </div>
                <div className="md:w-2/3" data-id="element-381">
                  <p className="text-lg text-[#4a5568] mb-4" data-id="element-382">
                    Sofía despertaba cada día con ese mismo dolor punzante en la
                    frente. Pastillas. Terapias. Nada funcionaba.
                  </p>
                  <p className="text-lg text-[#4a5568] mb-4" data-id="element-383">
                    Hasta que un día se detuvo, respiró profundo, y decidió
                    probar esto.
                  </p>
                  <p className="text-lg text-[#4a5568] mb-4" data-id="element-384">
                    <span className="font-semibold" data-id="element-385">
                      15 minutos después, algo cambió.
                    </span>{' '}
                    El dolor no estaba. Y por primera vez en años, se sintió
                    libre.
                  </p>
                </div>
              </div>
              <div className="text-center mt-8" data-id="element-386">
                <p className="text-xl text-[#4a5568] italic" data-id="element-387">
                  Quizá tú también te sientes como Sofía. Y está bien. Porque
                  eso está a punto de cambiar.
                </p>
              </div>
              <div className="mt-12 p-6 bg-[#f8f9ff] rounded-xl border border-[#e2e8f0]" data-id="element-388">
                <h3 className="text-2xl font-semibold mb-4 text-[#1e293b]" data-id="element-389">
                  Tal vez te dijeron que el dolor es parte de ti.
                </h3>
                <p className="text-lg text-[#4a5568]" data-id="element-390">
                  Pero eso es una mentira que se ha repetido demasiado tiempo.
                  No eres tu dolor. Y no tienes que seguir cargándolo.
                </p>
                <p className="text-lg text-[#4a5568] mt-4 font-medium" data-id="element-391">
                  Este dispositivo no es magia. Es ciencia aplicada a tu
                  autonomía.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(Story);